<!-- calendar-color-form.component.html -->
<mat-card class="configuration-card color-config-card">
  <mat-card-header>
    <mat-card-title>Calendar Color Configuration</mat-card-title>
    <mat-card-subtitle>
      Customize the colors used for each type on the calendar. Click a swatch to change its color.
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="position-relative">
      <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

      <form [formGroup]="calendarColorForm" (ngSubmit)="onSubmit()">
        <app-success-message [message]="successMessage"></app-success-message>
        <app-error-message [message]="errorMessage"></app-error-message>

        <section class="color-config-section" *ngFor="let type of taxonomyTypes" [formArrayName]="type">
          <header class="color-config-section-header">
            <h2 class="color-config-section-title">{{ getTaxonomyTypeDisplayName(type) }}</h2>
            <span class="color-config-count" *ngIf="getOverrideCount(type) > 0">
              {{ getOverrideCount(type) }} customized
            </span>
          </header>

          <div class="color-config-grid">
            <ng-container *ngFor="let term of getFormArray(type)?.controls; let i = index">
              <div [formGroupName]="i" class="color-card" *ngIf="term" [class.color-card--custom]="isOverridden(type, i)">

                <!-- Swatch: native picker overlaid invisibly -->
                <label class="color-swatch" [style.background]="term.get('color')?.value" [title]="'Change color for ' + term.get('name')?.value">
                  <input
                    type="color"
                    class="color-swatch-input"
                    formControlName="color"
                    (change)="onValueChange(type, i)"
                    [attr.aria-label]="'Color for ' + term.get('name')?.value">
                  <span class="material-icons color-swatch-icon">edit</span>
                </label>

                <div class="color-card-body">
                  <span class="color-card-name" [title]="term.get('name')?.value">{{ term.get('name')?.value }}</span>
                  <span class="color-card-hex">{{ (term.get('color')?.value || '') | uppercase }}</span>
                </div>

                <div class="color-card-footer">
                  <span class="color-config-badge" *ngIf="isOverridden(type, i)">Custom</span>
                  <span class="color-config-badge color-config-badge--muted" *ngIf="!isOverridden(type, i)">Default</span>
                  <button
                    mat-icon-button
                    type="button"
                    class="color-config-reset"
                    (click)="resetToDefault(type, i)"
                    matTooltip="Reset to default"
                    [disabled]="!isOverridden(type, i)">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>

                <mat-error class="color-config-error" *ngIf="term.get('color')?.invalid">
                  Invalid hex color.
                </mat-error>
              </div>
            </ng-container>

            <p class="color-config-empty" *ngIf="!showProgressSpinner && getFormArray(type)?.controls?.length === 0">
              No types found in this category.
            </p>
          </div>
        </section>
      </form>
    </div>
  </mat-card-content>

  <mat-card-actions align="end" class="color-config-actions">
    <span class="color-config-changes-hint" *ngIf="hasChanges">You have unsaved changes</span>
    <button mat-raised-button color="primary" type="submit" [disabled]="!hasChanges" (click)="onSubmit()">
      <mat-icon>save</mat-icon>
      Update Colors
    </button>
  </mat-card-actions>
</mat-card>
